import { ElementRef, Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportTableAsExcelFile(table: ElementRef, excelFileName: string): void {
    
    const myworksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table.nativeElement);
    const myworkbook: XLSX.WorkBook = { Sheets: { 'data': myworksheet }, SheetNames: ['export'] };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportJsonAsExcelFile(json: any[], excelFileName: string, columns: string[] = undefined, parameters: any[][] = undefined): void {
    
    const myworkbook: XLSX.WorkBook = XLSX.utils.book_new();
    var myworksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);
    XLSX.utils.book_append_sheet(myworkbook, myworksheet, "export");

    let row = 0;
    if (parameters) {
        XLSX.utils.sheet_add_aoa(myworksheet, parameters, { origin: row });
        row += parameters.length + 1;
    }

    XLSX.utils.sheet_add_aoa(myworksheet, [columns], { origin: row });
    XLSX.utils.sheet_add_json(myworksheet, json, { origin: row + 1, skipHeader: true });

    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

}


// WEBPACK FOOTER //
// ./src/app/common/excel.service.ts